(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1055,6107],{

/***/ 24026:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return __webpack_require__(6738);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 6738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blogs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./styles/BlogsLanding.module.scss
var BlogsLanding_module = __webpack_require__(79718);
var BlogsLanding_module_default = /*#__PURE__*/__webpack_require__.n(BlogsLanding_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 18 modules
var Modal = __webpack_require__(13540);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
;// CONCATENATED MODULE: ./utils/blogCategoriesApi.ts

/**
 * Fetches student destination categories from the API
 * Excludes "News" category from the results
 */ const fetchStudentDestinationCategories = async ()=>{
    try {
        const res = await (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/stu-dest-categories?category_ncontains=News&_fields=id,category,count`, "GET", {}, "", false);
        if (!res || !Array.isArray(res)) {
            return [];
        }
        return res;
    } catch (error) {
        console.error("Error fetching student destination categories:", error);
        return [];
    }
};
/**
 * Fetches course categories from the API and transforms them to match expected format
 * Converts course names to slug-like values (e.g., "Business Administration & Management" -> "business_administration_management")
 */ const fetchCourseCategories = async ()=>{
    try {
        const res = await (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/study-courses`, "GET", {}, "", false);
        if (!res || !Array.isArray(res)) {
            return [];
        }
        // Transform API response to match expected format
        const transformedCategories = res.map((item)=>{
            // Convert course name to slug-like value (similar to constants format)
            // Handles: "Business Administration & Management" -> "business_administration_management"
            // Handles: "Health Care + Pharma" -> "health_care_pharma"
            const value = item.courses.toLowerCase().replace(/&/g, "").replace(/\+/g, "").replace(/\s+/g, "_").replace(/_+/g, "_") // Replace multiple underscores with single
            .replace(/^_|_$/g, "") // Remove leading/trailing underscores
            .trim();
            return {
                label: item.courses,
                value: value
            };
        });
        return transformedCategories;
    } catch (error) {
        console.error("Error fetching course categories:", error);
        return [];
    }
};
/**
 * Fetches coaching categories from the API and transforms them to match expected format
 * Uses Categories field as both label and value (e.g., "IELTS", "TOEFL", "PTE")
 */ const fetchCoachingCategories = async ()=>{
    try {
        const res = await (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/coaching-categories`, "GET", {}, "", false);
        if (!res || !Array.isArray(res)) {
            return [];
        }
        // Transform API response to match expected format
        const transformedCategories = res.map((item)=>{
            // Use Categories field as both label and value
            // Values like "IELTS", "TOEFL", "PTE" match the constants format
            return {
                label: item.Categories,
                value: item.Categories
            };
        });
        return transformedCategories;
    } catch (error) {
        console.error("Error fetching coaching categories:", error);
        return [];
    }
};
/**
 * Fetches success stories categories from the API and transforms them to match expected format
 * Converts storyCategories to lowercase value format (e.g., "Student" -> "student", "Partner Associate" -> "partner_associate")
 */ const fetchSuccessStoriesCategories = async ()=>{
    try {
        const res = await (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/success-stories-categories`, "GET", {}, "", false);
        if (!res || !Array.isArray(res)) {
            return [];
        }
        // Transform API response to match expected format
        const transformedCategories = res.map((item)=>{
            // Convert storyCategories to lowercase value format
            // Handles: "Student" -> "student", "Partner Associate" -> "partner_associate"
            const value = item.storyCategories.toLowerCase().replace(/\s+/g, "_").trim();
            return {
                label: item.storyCategories,
                value: value
            };
        });
        return transformedCategories;
    } catch (error) {
        console.error("Error fetching success stories categories:", error);
        return [];
    }
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var b2c_constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./components/BlogsLanding.tsx
























const BLOGS_PAGE_SIZE = 18;
const Blogs = (props)=>{
    const router = (0,next_router.useRouter)();
    const { 0: blogsdata , 1: setBlogsdata  } = (0,react.useState)([]);
    const { 0: blogsCount , 1: setBlogsCount  } = (0,react.useState)(0);
    const { 0: clickFilter , 1: setClickFilter  } = (0,react.useState)(0);
    const { 0: filters , 1: setFilters  } = (0,react.useState)({
        searchValue: "",
        category: "",
        course: "",
        coaching: "",
        successStories: "",
        recruiters: false,
        institutes: false
    });
    const { 0: searchKeyword , 1: setSearchKeyword  } = (0,react.useState)("");
    const { 0: searchQuery , 1: setSearchQuery  } = (0,react.useState)({});
    const { 0: isLoadingMore , 1: setIsLoadingMore  } = (0,react.useState)(false);
    const { category , searchValue , course , coaching , successStories , recruiters , institutes  } = filters;
    const { 0: studentDestinationCategories , 1: setStudentDestinationCategories  } = (0,react.useState)([]);
    const { 0: courseCategories , 1: setCourseCategories  } = (0,react.useState)([]);
    const { 0: coachingCategories , 1: setCoachingCategories  } = (0,react.useState)([]);
    const { 0: successStoriesCategories , 1: setSuccessStoriesCategories  } = (0,react.useState)([]);
    const { 0: stickyHeaderActive , 1: setStickyHeaderActive  } = (0,react.useState)(false);
    const debounceSearchQuery = (searchKeyValue)=>{
        const search = debounce_default()(()=>setFilters({
                ...filters,
                searchValue: searchKeyValue
            }), 500);
        setSearchQuery((prevSearch)=>{
            if (prevSearch.cancel) {
                prevSearch.cancel();
            }
            return search;
        });
        search();
    };
    const getBlogsFilterConditions = ()=>{
        const searchCondition = searchValue ? `&title_contains=${searchValue}` : "";
        const categoryCondition = category ? `&stu_dest_categories.category_contains=${category}` : "";
        const courseCondition = course ? `&courseCategory=${course}` : "";
        const coachingCondition = coaching ? `&coachingCategory=${constants/* COACHING_CATEGORY_ENUM */.rq[coaching] || coaching}` : "";
        const successStoriesCondition = successStories ? `&successStoriesCategory=${successStories}` : "";
        const recruiterCondition = recruiters ? `&forRecruiters=${recruiters}` : "";
        const institutesCondition = institutes ? `&forInstitutes=${institutes}` : "";
        return `${searchCondition}${categoryCondition}${courseCondition}${coachingCondition}${successStoriesCondition}${recruiterCondition}${institutesCondition}`;
    };
    (0,react.useEffect)(()=>{
        const conditions = getBlogsFilterConditions();
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category_ncontains=News&_limit=${BLOGS_PAGE_SIZE}${conditions}`, "GET", {}, "", false).then((res)=>{
            setBlogsdata(res);
        });
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/blogs/count?_start=0&stu_dest_categories.category_ncontains=News${conditions}`, "GET", {}, "", false).then((res)=>{
            setBlogsCount(res);
        });
    }, [
        filters
    ]);
    const filtersRef = (0,react.useRef)(filters);
    (0,react.useEffect)(()=>{
        filtersRef.current = filters;
    }, [
        filters
    ]);
    const handleViewMore = ()=>{
        const requestFilters = filters;
        setIsLoadingMore(true);
        const conditions = getBlogsFilterConditions();
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/blogs?_sort=date:DESC&_start=${blogsdata.length}&stu_dest_categories.category_ncontains=News&_limit=${BLOGS_PAGE_SIZE}${conditions}`, "GET", {}, "", false).then((res)=>{
            if (filtersRef.current === requestFilters) {
                setBlogsdata((prev)=>[
                        ...prev,
                        ...res
                    ]);
            }
        }).finally(()=>{
            setIsLoadingMore(false);
        });
    };
    (0,react.useEffect)(()=>{
        fetchStudentDestinationCategories().then((res)=>{
            setStudentDestinationCategories(res);
        });
    }, []);
    (0,react.useEffect)(()=>{
        fetchCourseCategories().then((res)=>{
            setCourseCategories(res);
        });
    }, []);
    (0,react.useEffect)(()=>{
        fetchCoachingCategories().then((res)=>{
            setCoachingCategories(res);
        });
    }, []);
    (0,react.useEffect)(()=>{
        fetchSuccessStoriesCategories().then((res)=>{
            setSuccessStoriesCategories(res);
        });
    }, []);
    const { 0: show , 1: setShow  } = (0,react.useState)(false);
    const { 0: selCategory , 1: setSelCategory  } = (0,react.useState)({
        category: "",
        course: "",
        coaching: "",
        successStories: "",
        recruiters: false,
        institutes: false
    });
    const handleClose = ()=>setShow(false);
    const handleShow = ()=>setShow(true);
    const scrollRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const handleScroll = ()=>{
        const scrollTop = window.scrollY;
        setStickyHeaderActive(scrollTop >= 1100);
    };
    const handleClick = ()=>{
        if (stickyHeaderActive && scrollRef.current) {
            scrollRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            scrollRef.current.style.paddingTop = "60px";
        }
    };
    // Helper function to get active filters with their display names
    const getActiveFilters = ()=>{
        const activeFilters = [];
        if (filters.category) {
            activeFilters.push({
                type: "category",
                label: filters.category,
                value: filters.category
            });
        }
        if (filters.course) {
            const courseLabel = (0,helpers/* getBlogName */.LE)(filters.course, courseCategories) || filters.course;
            activeFilters.push({
                type: "course",
                label: courseLabel,
                value: filters.course
            });
        }
        if (filters.coaching) {
            const coachingLabel = (0,helpers/* getBlogName */.LE)(filters.coaching, coachingCategories) || filters.coaching;
            activeFilters.push({
                type: "coaching",
                label: coachingLabel,
                value: filters.coaching
            });
        }
        if (filters.successStories) {
            const successStoriesLabel = (0,helpers/* getBlogName */.LE)(filters.successStories, successStoriesCategories) || filters.successStories;
            activeFilters.push({
                type: "successStories",
                label: successStoriesLabel,
                value: filters.successStories
            });
        }
        if (filters.recruiters) {
            activeFilters.push({
                type: "recruiters",
                label: "For Recruiters",
                value: true
            });
        }
        if (filters.institutes) {
            activeFilters.push({
                type: "institutes",
                label: "For Institutes",
                value: true
            });
        }
        return activeFilters;
    };
    // Function to remove individual filter
    const removeFilter = (filterType)=>{
        setFilters({
            ...filters,
            [filterType]: filterType === "recruiters" || filterType === "institutes" ? false : ""
        });
        handleClick();
    };
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: props?.pageData?.bannerBtn?.btnLink,
        formId: props?.pageData?.bannerBtn?.formId,
        toOnboardingEnabled: props?.pageData?.bannerBtn?.toOnboardingEnabled
    });
    const enquireNowClickHandler = (e)=>{
        if (applyCtaButtonProps.mode === "onboarding") {
            (0,sourceTracking/* persistSourceContext */.jW)({
                sourceUrl: window.location.href,
                primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                fifthStepVisible: props?.pageData?.bannerBtn?.onBoardingFlow?.nearestOffice ?? true,
                coachingVisible: props?.pageData?.bannerBtn?.onBoardingFlow?.lookingForCoaching ?? true
            });
        }
        applyCtaButtonProps.onClick?.(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "/images/newsandpress/news-bg.svg",
                        rel: "preload",
                        as: "image",
                        fetchpriority: "high"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: blogsdata?.[0]?.newimageUrl?.imageUrl,
                        rel: "preload",
                        as: "image",
                        fetchpriority: "high"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BlogsLanding_module_default()).newpress,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BlogsLanding_module_default()).curve,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "blogheading",
                            className: (BlogsLanding_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        lg: 8,
                                        md: 8,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-block d-sm-none text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (BlogsLanding_module_default()).breadcrum,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        className: (BlogsLanding_module_default()).mobileBreadCrum,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                href: "/",
                                                                children: "Home"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: "Blogs"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (BlogsLanding_module_default()).heading,
                                                ref: scrollRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (BlogsLanding_module_default()).breadcrum,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                            className: "d-none d-sm-block",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    href: "/",
                                                                    children: "Home"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    href: "",
                                                                    children: "Blog"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: props?.pageData?.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: props?.pageData?.description
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        id: "enquirebtn",
                                                        variant: "primary",
                                                        size: "lg",
                                                        className: `${(BlogsLanding_module_default()).enquirebtn} btn ${applyCtaButtonProps.formClassName}`,
                                                        onClick: enquireNowClickHandler,
                                                        children: props?.pageData?.bannerBtn?.label || "Enquire Now"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BlogsLanding_module_default()).BlogLandingFeaturedNews,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: scrollRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "latestblogs",
                        className: (BlogsLanding_module_default()).latestNew,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (BlogsLanding_module_default()).customContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (BlogsLanding_module_default()).heading,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: "All Blogs"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (BlogsLanding_module_default()).news,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: `${(BlogsLanding_module_default()).filtersDrop} ${(BlogsLanding_module_default()).filterTop} ${stickyHeaderActive ? (BlogsLanding_module_default()).isSticky : ""}`,
                                                id: "stickyHeader",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                                        className: (BlogsLanding_module_default()).container,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                className: `${(BlogsLanding_module_default()).topFilter} justify-content-center'`,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                        xl: 12,
                                                                        lg: 12,
                                                                        md: 12,
                                                                        sm: 12,
                                                                        xs: 12,
                                                                        className: (BlogsLanding_module_default()).filtercheck,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (BlogsLanding_module_default()).selectdiv,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).Selectfilt} ${clickFilter === 1 ? (BlogsLanding_module_default()).activeSelect : ""} ${filters.category && (BlogsLanding_module_default()).selectedFilter}`,
                                                                                    onClick: ()=>!clickFilter ? setClickFilter(1) : setClickFilter(0),
                                                                                    children: [
                                                                                        "Study Destinations",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                            src: clickFilter === 1 ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                                                                            width: 20,
                                                                                            height: 8,
                                                                                            alt: "uparrowblue.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).Selectfilt} ${clickFilter === 2 ? (BlogsLanding_module_default()).activeSelect : ""} ${filters.course && (BlogsLanding_module_default()).selectedFilter}`,
                                                                                    onClick: ()=>!clickFilter ? setClickFilter(2) : setClickFilter(0),
                                                                                    children: [
                                                                                        "Courses",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                            src: clickFilter === 2 ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                                                                            width: 20,
                                                                                            height: 8,
                                                                                            alt: "uparrowblue.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).Selectfilt} ${clickFilter === 3 ? (BlogsLanding_module_default()).activeSelect : ""} ${filters.coaching && (BlogsLanding_module_default()).selectedFilter}`,
                                                                                    onClick: ()=>!clickFilter ? setClickFilter(3) : setClickFilter(0),
                                                                                    children: [
                                                                                        "Coaching",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                            src: clickFilter === 3 ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                                                                            width: 20,
                                                                                            height: 8,
                                                                                            alt: "uparrowblue.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).Selectfilt} ${clickFilter === 4 ? (BlogsLanding_module_default()).activeSelect : ""} ${filters.successStories && (BlogsLanding_module_default()).selectedFilter}`,
                                                                                    onClick: ()=>!clickFilter ? setClickFilter(4) : setClickFilter(0),
                                                                                    children: [
                                                                                        "Success Stories",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                            src: clickFilter === 4 ? "/uparrowblue.svg" : "/downarrowgr.svg",
                                                                                            width: 20,
                                                                                            height: 8,
                                                                                            alt: "uparrowblue.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).Selectfilt} ${(BlogsLanding_module_default()).recruiterFilter} ${filters.recruiters === true && (BlogsLanding_module_default()).activeRecruiterFilter}`,
                                                                                    onClick: ()=>{
                                                                                        setClickFilter(0);
                                                                                        setFilters({
                                                                                            ...filters,
                                                                                            recruiters: !recruiters
                                                                                        });
                                                                                    //scrollRef?.current?.scrollIntoView();
                                                                                    },
                                                                                    children: "For Recruiters"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).Selectfilt} ${(BlogsLanding_module_default()).recruiterFilter} ${filters.institutes === true && (BlogsLanding_module_default()).activeRecruiterFilter}`,
                                                                                    onClick: ()=>{
                                                                                        setClickFilter(0);
                                                                                        setFilters({
                                                                                            ...filters,
                                                                                            institutes: !institutes
                                                                                        });
                                                                                    //scrollRef?.current?.scrollIntoView();
                                                                                    },
                                                                                    children: "For Institutes"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (BlogsLanding_module_default()).clearFilter,
                                                                                    onClick: ()=>{
                                                                                        setFilters({
                                                                                            searchValue: "",
                                                                                            category: "",
                                                                                            course: "",
                                                                                            coaching: "",
                                                                                            successStories: "",
                                                                                            recruiters: false,
                                                                                            institutes: false
                                                                                        });
                                                                                        setSearchKeyword("");
                                                                                        setClickFilter(0);
                                                                                    //scrollRef?.current?.scrollIntoView();
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                        children: "Clear Filter"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (BlogsLanding_module_default()).searchWrapInRow,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                                                        className: "navbar-form",
                                                                                        role: "search",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "input-group add-on",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: (BlogsLanding_module_default()).inputBox,
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                        className: "form-control",
                                                                                                        placeholder: "Search Blogs",
                                                                                                        name: "srch-term",
                                                                                                        id: "srch-term",
                                                                                                        type: "text",
                                                                                                        onChange: (e)=>{
                                                                                                            const searchValues = e.target.value;
                                                                                                            debounceSearchQuery(searchValues);
                                                                                                            setSearchKeyword(searchValues);
                                                                                                            scrollRef?.current?.scrollIntoView();
                                                                                                        },
                                                                                                        value: searchKeyword
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: (BlogsLanding_module_default()).inputBtn,
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                                            src: "/searchco.svg",
                                                                                                            alt: "searchco",
                                                                                                            width: 14,
                                                                                                            height: 14,
                                                                                                            onClick: ()=>scrollRef?.current?.scrollIntoView()
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                        lg: 3,
                                                                        md: 3,
                                                                        sm: 2,
                                                                        xs: 3,
                                                                        className: (BlogsLanding_module_default()).mobilemenu,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (BlogsLanding_module_default()).btn,
                                                                            onClick: ()=>{
                                                                                handleShow();
                                                                                setClickFilter(1);
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: "/new-images/threeline-menu.svg",
                                                                                alt: "threelineMenu",
                                                                                width: 18,
                                                                                height: 12
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            getActiveFilters().length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                                className: (BlogsLanding_module_default()).topFilter,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xl: 12,
                                                                    lg: 12,
                                                                    md: 12,
                                                                    sm: 12,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (BlogsLanding_module_default()).selectedFiltersChips,
                                                                        children: getActiveFilters().map((filter, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (BlogsLanding_module_default()).selectedFilterChip,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: (BlogsLanding_module_default()).chipText,
                                                                                        children: filter.label
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        className: (BlogsLanding_module_default()).chipRemove,
                                                                                        onClick: ()=>removeFilter(filter.type),
                                                                                        "aria-label": `Remove ${filter.label} filter`,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                                            width: "16",
                                                                                            height: "16",
                                                                                            viewBox: "0 0 16 16",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                                    d: "M12 4L4 12",
                                                                                                    stroke: "#226CF5",
                                                                                                    strokeWidth: "1.5",
                                                                                                    strokeLinecap: "round"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                                    d: "M4 4L12 12",
                                                                                                    stroke: "#226CF5",
                                                                                                    strokeWidth: "1.5",
                                                                                                    strokeLinecap: "round"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, index))
                                                                    })
                                                                })
                                                            }),
                                                            clickFilter === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                                className: (BlogsLanding_module_default()).topFilter,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xl: 12,
                                                                    lg: 12,
                                                                    md: 12,
                                                                    sm: 12,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (BlogsLanding_module_default()).filterSelectGrid,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (BlogsLanding_module_default()).filterSelectGridContainer,
                                                                            children: studentDestinationCategories?.map((type, index)=>index !== 10 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).filterSelectGridItem} ${filters.category === type.category ? (BlogsLanding_module_default()).filterSelectGridItemSelected : ""}`,
                                                                                    onClick: ()=>{
                                                                                        setFilters({
                                                                                            ...filters,
                                                                                            category: type.category
                                                                                        });
                                                                                        setClickFilter(0);
                                                                                        handleClick();
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridText,
                                                                                            children: type.category
                                                                                        }),
                                                                                        type.count && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridBadge,
                                                                                            children: type.count
                                                                                        })
                                                                                    ]
                                                                                }, index))
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            clickFilter === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                                className: (BlogsLanding_module_default()).topFilter,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xl: 12,
                                                                    lg: 12,
                                                                    md: 12,
                                                                    sm: 12,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (BlogsLanding_module_default()).filterSelectGrid,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (BlogsLanding_module_default()).filterSelectGridContainer,
                                                                            children: courseCategories.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).filterSelectGridItem} ${filters.course === type.value ? (BlogsLanding_module_default()).filterSelectGridItemSelected : ""}`,
                                                                                    onClick: ()=>{
                                                                                        setFilters({
                                                                                            ...filters,
                                                                                            course: type.value
                                                                                        });
                                                                                        setClickFilter(0);
                                                                                        handleClick();
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridText,
                                                                                            children: type.label
                                                                                        }),
                                                                                        type.count && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridBadge,
                                                                                            children: type.count
                                                                                        })
                                                                                    ]
                                                                                }, index))
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            clickFilter === 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                                className: (BlogsLanding_module_default()).topFilter,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xl: 12,
                                                                    lg: 12,
                                                                    md: 12,
                                                                    sm: 12,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (BlogsLanding_module_default()).filterSelectGrid,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (BlogsLanding_module_default()).filterSelectGridContainer,
                                                                            children: coachingCategories.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).filterSelectGridItem} ${filters.coaching === type.value ? (BlogsLanding_module_default()).filterSelectGridItemSelected : ""}`,
                                                                                    onClick: ()=>{
                                                                                        setFilters({
                                                                                            ...filters,
                                                                                            coaching: type.value
                                                                                        });
                                                                                        setClickFilter(0);
                                                                                        handleClick();
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridText,
                                                                                            children: type.label
                                                                                        }),
                                                                                        type.count && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridBadge,
                                                                                            children: type.count
                                                                                        })
                                                                                    ]
                                                                                }, index))
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            clickFilter === 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                                className: (BlogsLanding_module_default()).topFilter,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xl: 12,
                                                                    lg: 12,
                                                                    md: 12,
                                                                    sm: 12,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (BlogsLanding_module_default()).filterSelectGrid,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (BlogsLanding_module_default()).filterSelectGridContainer,
                                                                            children: successStoriesCategories.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: `${(BlogsLanding_module_default()).filterSelectGridItem} ${filters.successStories === type.value ? (BlogsLanding_module_default()).filterSelectGridItemSelected : ""}`,
                                                                                    onClick: ()=>{
                                                                                        setFilters({
                                                                                            ...filters,
                                                                                            successStories: type.value
                                                                                        });
                                                                                        setClickFilter(0);
                                                                                        handleClick();
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridText,
                                                                                            children: type.label
                                                                                        }),
                                                                                        type.count && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: (BlogsLanding_module_default()).filterSelectGridBadge,
                                                                                            children: type.count
                                                                                        })
                                                                                    ]
                                                                                }, index))
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                                                        show: show,
                                                        onHide: handleClose,
                                                        className: (BlogsLanding_module_default()).filtCat,
                                                        centered: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                                                                className: `show-grid ${(BlogsLanding_module_default()).modalBodyScroll}`,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                                                    className: (BlogsLanding_module_default()).contain,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                            className: (BlogsLanding_module_default()).row,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 3,
                                                                                    md: 3,
                                                                                    sm: 3,
                                                                                    className: (BlogsLanding_module_default()).col,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: `${(BlogsLanding_module_default()).catfilter} ${clickFilter === 1 && (BlogsLanding_module_default()).catSelected}`,
                                                                                        onClick: ()=>setClickFilter(1),
                                                                                        children: "Study Destinations"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 2,
                                                                                    md: 2,
                                                                                    sm: 2,
                                                                                    className: (BlogsLanding_module_default()).col,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: `${(BlogsLanding_module_default()).catfilter} ${clickFilter === 2 && (BlogsLanding_module_default()).catSelected}`,
                                                                                        onClick: ()=>setClickFilter(2),
                                                                                        children: "Courses"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 2,
                                                                                    md: 2,
                                                                                    sm: 2,
                                                                                    className: (BlogsLanding_module_default()).col,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: `${(BlogsLanding_module_default()).catfilter} ${clickFilter === 3 && (BlogsLanding_module_default()).catSelected}`,
                                                                                        onClick: ()=>setClickFilter(3),
                                                                                        children: "Coaching"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 2,
                                                                                    md: 2,
                                                                                    sm: 2,
                                                                                    className: (BlogsLanding_module_default()).col,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: `${(BlogsLanding_module_default()).catfilter} ${clickFilter === 4 && (BlogsLanding_module_default()).catSelected}`,
                                                                                        onClick: ()=>setClickFilter(4),
                                                                                        children: "Success Stories"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 2,
                                                                                    md: 2,
                                                                                    sm: 2,
                                                                                    className: (BlogsLanding_module_default()).col,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: `${(BlogsLanding_module_default()).catfilter} ${(BlogsLanding_module_default()).recruiterFilter} ${selCategory.recruiters === true && (BlogsLanding_module_default()).activeRecruiterFilter}`,
                                                                                        onClick: ()=>{
                                                                                            setClickFilter(4);
                                                                                            setSelCategory({
                                                                                                ...selCategory,
                                                                                                recruiters: !selCategory.recruiters
                                                                                            });
                                                                                        },
                                                                                        children: "For Recruiter"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 2,
                                                                                    md: 2,
                                                                                    sm: 2,
                                                                                    className: (BlogsLanding_module_default()).col,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: `${(BlogsLanding_module_default()).catfilter} ${(BlogsLanding_module_default()).recruiterFilter} ${selCategory.institutes === true && (BlogsLanding_module_default()).activeRecruiterFilter}`,
                                                                                        onClick: ()=>{
                                                                                            setClickFilter(4);
                                                                                            setSelCategory({
                                                                                                ...selCategory,
                                                                                                institutes: !selCategory.institutes
                                                                                            });
                                                                                        },
                                                                                        children: "For Institutes"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                            children: [
                                                                                clickFilter === 1 && studentDestinationCategories?.map((type, index)=>type.category !== "News" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: `${(BlogsLanding_module_default()).optfilter} ${selCategory.category === type.category ? (BlogsLanding_module_default()).optSelected : ""}`,
                                                                                            onClick: ()=>setSelCategory({
                                                                                                    ...selCategory,
                                                                                                    category: type.category
                                                                                                }),
                                                                                            children: type.category
                                                                                        })
                                                                                    }, index)),
                                                                                clickFilter === 2 && courseCategories.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: `${(BlogsLanding_module_default()).optfilter} ${selCategory.course === type.value ? (BlogsLanding_module_default()).optSelected : ""}`,
                                                                                            onClick: ()=>setSelCategory({
                                                                                                    ...selCategory,
                                                                                                    course: type.value
                                                                                                }),
                                                                                            children: type.label
                                                                                        })
                                                                                    }, index)),
                                                                                clickFilter === 3 && coachingCategories.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: `${(BlogsLanding_module_default()).optfilter} ${selCategory.coaching === type.value ? (BlogsLanding_module_default()).optSelected : ""}`,
                                                                                            onClick: ()=>setSelCategory({
                                                                                                    ...selCategory,
                                                                                                    coaching: type.value
                                                                                                }),
                                                                                            children: type.label
                                                                                        })
                                                                                    }, index)),
                                                                                clickFilter === 4 && successStoriesCategories.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: `${(BlogsLanding_module_default()).optfilter} ${selCategory.successStories === type.value ? (BlogsLanding_module_default()).optSelected : ""}`,
                                                                                            onClick: ()=>setSelCategory({
                                                                                                    ...selCategory,
                                                                                                    successStories: type.value
                                                                                                }),
                                                                                            children: type.label
                                                                                        })
                                                                                    }, index))
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Footer */.Z.Footer, {
                                                                className: (BlogsLanding_module_default()).footerSpace,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        className: (BlogsLanding_module_default()).btnClose,
                                                                        variant: "link",
                                                                        onClick: ()=>{
                                                                            handleClose();
                                                                        },
                                                                        children: "Close"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        className: (BlogsLanding_module_default()).btnsecondary,
                                                                        variant: "secondary",
                                                                        onClick: ()=>{
                                                                            setFilters({
                                                                                searchValue: "",
                                                                                category: "",
                                                                                course: "",
                                                                                coaching: "",
                                                                                successStories: "",
                                                                                recruiters: false,
                                                                                institutes: false
                                                                            });
                                                                            setSearchKeyword("");
                                                                            setClickFilter(0);
                                                                            setSelCategory({
                                                                                category: "",
                                                                                course: "",
                                                                                coaching: "",
                                                                                successStories: "",
                                                                                recruiters: false,
                                                                                institutes: false
                                                                            });
                                                                            handleClose();
                                                                            scrollRef?.current?.scrollIntoView();
                                                                        },
                                                                        children: "Clear Filter"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        className: (BlogsLanding_module_default()).btnprimary,
                                                                        variant: "primary",
                                                                        onClick: ()=>{
                                                                            setFilters({
                                                                                ...filters,
                                                                                ...selCategory
                                                                            });
                                                                            handleClose();
                                                                            scrollRef?.current?.scrollIntoView();
                                                                        },
                                                                        children: "Apply Filters"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (BlogsLanding_module_default()).allBlogs,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                    children: blogsdata.length > 0 ? blogsdata.map((blog, index)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                xxl: 4,
                                                                xl: 4,
                                                                lg: 6,
                                                                md: 6,
                                                                sm: 12,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: `/blogs/${blog.slug}`,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                                        className: (BlogsLanding_module_default()).card,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (BlogsLanding_module_default()).latestBlogImg,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Img */.Z.Img, {
                                                                                    variant: "top",
                                                                                    src: blog.blogLandingCardImage?.imageUrl ? blog.blogLandingCardImage.imageUrl : blog.newimageUrl?.imageUrl,
                                                                                    alt: blog.blogLandingCardImage?.alt ? blog.blogLandingCardImage.alt : blog.newimageUrl?.alt,
                                                                                    "object-fit": "fill"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                                                className: (BlogsLanding_module_default()).cardBody,
                                                                                children: [
                                                                                    blog.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                        className: (BlogsLanding_module_default()).blogsCategories,
                                                                                        children: blog.category
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                        children: blog.title
                                                                                    }),
                                                                                    blog.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        className: (BlogsLanding_module_default()).shortDescription,
                                                                                        children: blog.shortDescription
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (BlogsLanding_module_default()).bottom,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                children: [
                                                                                                    " ",
                                                                                                    (0,format["default"])(new Date(blog.date), constants/* formatOrder */.iV)
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                href: `/blogs/${blog.slug}`,
                                                                                                children: " Read More "
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }, index)
                                                        });
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (BlogsLanding_module_default()).noBlogs,
                                                        children: "No Blogs"
                                                    })
                                                })
                                            }),
                                            blogsdata.length < blogsCount && !isLoadingMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: handleViewMore,
                                                        className: (BlogsLanding_module_default()).viewMore,
                                                        children: "View More"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    isLoadingMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: `${(BlogsLanding_module_default()).loading} text-center`,
                                        children: "Loading..."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "whykc",
                        className: (BlogsLanding_module_default()).WhyKc,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (BlogsLanding_module_default()).customContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Learn more about KC Overseas"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: props?.pageData?.learnMore?.length > 0 && props?.pageData?.learnMore.map((data, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 4,
                                                md: 4,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-center mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (BlogsLanding_module_default()).img,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: data.imageUrl,
                                                                alt: "About-Us",
                                                                width: 90,
                                                                height: 90
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                            children: data.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: data.description
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: data.link.href,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (BlogsLanding_module_default()).viewMore,
                                                                children: data.link.label
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogsLanding = (Blogs);

;// CONCATENATED MODULE: ./pages/blogs.tsx





const BlogsPage = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    const updatedMeta = meta?.jotforms?.length === 0 ? {
        ...meta,
        jotforms: constants/* commonJotformScript */.Y4
    } : {
        ...meta
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            updatedMeta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...updatedMeta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogsLanding, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var blogs = (BlogsPage);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 79718:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newpress":"BlogsLanding_newpress__kV2Ti","curve":"BlogsLanding_curve__9AttO","content":"BlogsLanding_content__hOtTc","heading":"BlogsLanding_heading__km91z","enquirebtn":"BlogsLanding_enquirebtn__ojeZ0","servContent":"BlogsLanding_servContent__VqhY6","latestNew":"BlogsLanding_latestNew__oStxB","news":"BlogsLanding_news__2Kd6r","card":"BlogsLanding_card__9Velp","latestBlogImg":"BlogsLanding_latestBlogImg__ZZ2rA","cardBody":"BlogsLanding_cardBody__V2HRc","blogsCategories":"BlogsLanding_blogsCategories__KPuZ9","shortDescription":"BlogsLanding_shortDescription__44vcn","cardTitile":"BlogsLanding_cardTitile__3_Lqk","bottom":"BlogsLanding_bottom__llKVp","viewMore":"BlogsLanding_viewMore__LnvNr","filtersDrop":"BlogsLanding_filtersDrop__0Drgd","container":"BlogsLanding_container__2_Hne","topFilter":"BlogsLanding_topFilter__EqfWv","filtercheck":"BlogsLanding_filtercheck__9Q691","selectdiv":"BlogsLanding_selectdiv__F2ZNh","Selectfilt":"BlogsLanding_Selectfilt__EWEtf","selectedFilter":"BlogsLanding_selectedFilter__rLFWq","recruiterFilter":"BlogsLanding_recruiterFilter__Lsg9a","activeSelect":"BlogsLanding_activeSelect__a7ici","filterSelect":"BlogsLanding_filterSelect__cw97S","courseCategory":"BlogsLanding_courseCategory__0vXxX","activeRecruiterFilter":"BlogsLanding_activeRecruiterFilter__yr6Mz","searchWrapInRow":"BlogsLanding_searchWrapInRow__HGzWV","input-group":"BlogsLanding_input-group__jKVvE","inputBox":"BlogsLanding_inputBox__QyW9e","form-control":"BlogsLanding_form-control__Io0pa","filterSelectGrid":"BlogsLanding_filterSelectGrid__0DNNN","filterSelectGridContainer":"BlogsLanding_filterSelectGridContainer__E7xh2","filterSelectGridItem":"BlogsLanding_filterSelectGridItem__Mjm5S","filterSelectGridItemSelected":"BlogsLanding_filterSelectGridItemSelected__0XDmz","filterSelectGridText":"BlogsLanding_filterSelectGridText__UBm4Z","filterSelectGridBadge":"BlogsLanding_filterSelectGridBadge__0hd6R","mobilemenu":"BlogsLanding_mobilemenu__MeES9","btn":"BlogsLanding_btn__If9_p","selectedFiltersChips":"BlogsLanding_selectedFiltersChips__QtELE","selectedFilterChip":"BlogsLanding_selectedFilterChip__EBbTw","chipText":"BlogsLanding_chipText__i44TG","chipRemove":"BlogsLanding_chipRemove__oPt7r","isSticky":"BlogsLanding_isSticky__Q3rmV","fadeInDown":"BlogsLanding_fadeInDown__oRpfw","breadcrum":"BlogsLanding_breadcrum__E5drL","buttongp":"BlogsLanding_buttongp__kxLfo","kcbtn":"BlogsLanding_kcbtn__GlPfh","centered":"BlogsLanding_centered__cE1gH","eduExpoBox":"BlogsLanding_eduExpoBox__zYodx","btEduExpo":"BlogsLanding_btEduExpo__J208d","breadcrumb-item":"BlogsLanding_breadcrumb-item__a8m_m","active":"BlogsLanding_active__bW6sC","hideimg":"BlogsLanding_hideimg__u7f3R","inputBtn":"BlogsLanding_inputBtn__qA4TH","BlogLandingFeaturedNews":"BlogsLanding_BlogLandingFeaturedNews__l_v9e","FeaturedNews":"BlogsLanding_FeaturedNews__DjMfN","WhyKc":"BlogsLanding_WhyKc__DP4sU","img":"BlogsLanding_img__BEatT","whyKcMobilePadding":"BlogsLanding_whyKcMobilePadding__H6x_Z","block":"BlogsLanding_block__TeaYe","customContainer":"BlogsLanding_customContainer__YaAzc","newpressdetail":"BlogsLanding_newpressdetail__64HZA","breadcrumb":"BlogsLanding_breadcrumb__vurxc","bg":"BlogsLanding_bg__PufR0","imgdiv":"BlogsLanding_imgdiv__ZP1P3","parentMain":"BlogsLanding_parentMain__X2Xjp","first":"BlogsLanding_first__OZJ4C","filtCat":"BlogsLanding_filtCat__AifIX","modalBodyScroll":"BlogsLanding_modalBodyScroll__qWHR_","footerSpace":"BlogsLanding_footerSpace__CSxai","btnClose":"BlogsLanding_btnClose__GaUO5","btnsecondary":"BlogsLanding_btnsecondary__0bRky","btnprimary":"BlogsLanding_btnprimary__YS6i1","contain":"BlogsLanding_contain__A0adH","row":"BlogsLanding_row__jZPdD","col":"BlogsLanding_col__VgPRp","catfilter":"BlogsLanding_catfilter__ZqFqm","catSelected":"BlogsLanding_catSelected__cOwiw","optfilter":"BlogsLanding_optfilter__DVYcX","optSelected":"BlogsLanding_optSelected__KafVc","clearFilter":"BlogsLanding_clearFilter___azpi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,3656,3784,5684,9774,2888,179], function() { return __webpack_exec__(24026); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);